module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "layui-btn",
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.icon) ? _c('v-icon', {
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-059489c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmButton.vue
// module id = 307
// module chunks = 2